export default class TrailerCtrl {
  static get UID() {
    return "trailerCtrl";
  }

  constructor(siteConst, $stateParams, sceneFac, $sce, BASE_URLS) {
    "ngInject";

    this.config = {
      preload: "none",
      plugins: {
        controls: {
          autoHide: true,
          autoHideTime: 5000
        }
      }
    };

    this.advertPoints = siteConst.advert.trailer;

    sceneFac.getTrailer($stateParams.updateId).then(scene => {
      const trailer = scene.trailer;
      if (trailer.link !== "") {
        var source = {
          src: $sce.trustAsResourceUrl(BASE_URLS.CONTENT + trailer.link),
          type: "video/" + trailer.type
        };
        this.config.sources = [source];

        if (trailer.width && trailer.height) {
          this.dims = {
            width: trailer.width + "px",
            height: trailer.height + "px",
            stageHeight: trailer.height + 10 + "px"
          };
        }
      }
      this.video = scene;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/features/trailerCtrl.js